import styled from 'styled-components'

const BindingStyled = styled.div`
  display: none;
  height: 0;
  width: 0;
`

export default BindingStyled
